'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, n = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), n.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t.push.apply(t, n);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, n, o = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(n = 0; n < c.length; n++)t = c[n], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
    }
    return o;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, n, o = {}, c = Object.keys(e);
    for(n = 0; n < c.length; n++)t = c[n], r.indexOf(t) >= 0 || (o[t] = e[t]);
    return o;
}
const Range = renderWithRef('Range', null, (t, n)=>{
    var { children: o, skin: c = 'standard', unfilled: p = false, gradientEndColor: s, gradientStartColor: a, style: i } = t, l = _object_without_properties(t, [
        "children",
        "skin",
        "unfilled",
        "gradientEndColor",
        "gradientStartColor",
        "style"
    ]);
    let u = [
        'swan-range'
    ];
    return p && u.push('swan-range-unfilled'), 'standard' !== c && u.push(`swan-range-skin-${c}`), jsx(RenderComp, {
        root: "input",
        classNames: u,
        forwardedRef: n,
        props: _object_spread_props(_object_spread({
            type: 'range'
        }, l), {
            style: _object_spread_props(_object_spread({}, i || {}), {
                '--swan-internal-range-gradient-start-color': a,
                '--swan-internal-range-gradient-end-color': s
            })
        }),
        children: o
    });
});

export { Range };
